var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"displayPage"},[_c('div',{staticClass:"btn"},[_vm._v("缓存清除完毕！")])])
}]

export { render, staticRenderFns }